import { render } from "./CustomerTestimonials.vue?vue&type=template&id=385bdd8a&scoped=true"
import script from "./CustomerTestimonials.vue?vue&type=script&lang=js"
export * from "./CustomerTestimonials.vue?vue&type=script&lang=js"

import "./CustomerTestimonials.vue?vue&type=style&index=0&id=385bdd8a&scoped=true&lang=css"
import "./CustomerTestimonials.vue?vue&type=style&index=1&id=385bdd8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385bdd8a"]])

export default __exports__